import React, { useState, useMemo } from "react";
import FormatoAuditoriaTesoreria from "./FormatoAuditoriaTesoreria";
import ReporteAuditoriaTesoreria from "./ReporteAuditoriaTesoreia";

export default function AuditoriaTesoreria({ usuario, onBackToMenu }) {
  const [vistaActiva, setVistaActiva] = useState("menu");

  // =====================================================================
  // 1. LÓGICA DE CONTROL ABAC
  // =====================================================================
  const permisosABAC = useMemo(() => {
    try {
      const parsed = typeof usuario?.permisos_avanzados === 'string' 
        ? JSON.parse(usuario.permisos_avanzados) 
        : (usuario?.permisos_avanzados || {});
      return parsed.micros || parsed; 
    } catch (e) { 
      return {}; 
    }
  }, [usuario]);

  const cargoUpper = String(usuario?.cargo || "").toUpperCase().trim();
  const esAdminGlobal = cargoUpper === "SUPER_ADMIN";

  const checkPermiso = (nombreSubmodulo) => {
    if (esAdminGlobal) return true;
    return permisosABAC[nombreSubmodulo] !== undefined;
  };

  const verChecklist = checkPermiso('Lista de Chequeo FT-AI-01');
  const verReportes = checkPermiso('Reportes de Tesorería');

  // =====================================================================
  // ENRUTADOR INTERNO
  // =====================================================================
  if (vistaActiva === "checklist") {
    return <FormatoAuditoriaTesoreria usuario={usuario} onBack={() => setVistaActiva("menu")} />;
  }
  
  if (vistaActiva === "reportes") {
    return <ReporteAuditoriaTesoreria usuario={usuario} permisosABAC={permisosABAC} onBack={() => setVistaActiva("menu")} />;
  }

  const sinPermisosModulo = !verChecklist && !verReportes;

  return (
    <div className="bg-slate-50/80 backdrop-blur-3xl p-6 sm:p-10 rounded-[32px] shadow-sm border border-white w-full max-w-5xl mx-auto animate-fade-in-up">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 pb-6 border-b border-gray-200 gap-4">
        <div>
          <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 tracking-tight">🏦 Auditoría de Tesorería</h2>
          <p className="text-sm text-gray-500 font-medium mt-1">Control de valores, arqueos y listas de chequeo de cajas.</p>
        </div>
        <button onClick={onBackToMenu} className="px-5 py-2.5 text-xs font-bold bg-white hover:bg-gray-50 text-gray-800 rounded-full border border-gray-200 cursor-pointer shadow-sm">
          Volver al Menú Principal
        </button>
      </div>

      {sinPermisosModulo ? (
        <div className="p-10 text-center bg-white/60 backdrop-blur-md border border-gray-100 rounded-3xl shadow-sm">
          <span className="text-4xl block mb-4">🛡️</span>
          <h3 className="text-lg font-black text-gray-800">Acceso Restringido</h3>
          <p className="text-xs text-gray-500 font-medium mt-2">No tienes herramientas de tesorería asignadas en tu matriz de privilegios.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto">
          
          {verChecklist && (
            <div 
              onClick={() => setVistaActiva("checklist")}
              className="bg-white/85 backdrop-blur-xl p-6 rounded-[24px] border border-blue-100 shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-lg transition-all cursor-pointer flex flex-col justify-between group hover:-translate-y-1"
            >
              <div>
                <div className="w-12 h-12 bg-emerald-50 text-emerald-600 rounded-full flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform shadow-inner">📝</div>
                <h3 className="text-lg font-extrabold text-gray-900 mb-1">Lista de Chequeo FT-AI-01</h3>
                <p className="text-xs text-gray-500 leading-relaxed">Formato digital de auditoría interna para tesorería, medios de pago y cajas.</p>
              </div>
              <div className="mt-6 flex items-center justify-between">
                <span className="text-[11px] font-bold px-3 py-1 rounded-full text-emerald-700 bg-emerald-50 border border-emerald-100">Nueva Auditoría</span>
                <span className="text-xs font-bold text-emerald-600 group-hover:translate-x-1 transition-transform">Ingresar ›</span>
              </div>
            </div>
          )}

          {verReportes && (
            <div 
              onClick={() => setVistaActiva("reportes")}
              className="bg-white/85 backdrop-blur-xl p-6 rounded-[24px] border border-blue-100 shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-lg transition-all cursor-pointer flex flex-col justify-between group hover:-translate-y-1"
            >
              <div>
                <div className="w-12 h-12 bg-purple-50 text-purple-600 rounded-full flex items-center justify-center text-2xl mb-4 group-hover:scale-110 transition-transform shadow-inner">🗂️</div>
                <h3 className="text-lg font-extrabold text-gray-900 mb-1">Historial y Reportes</h3>
                <p className="text-xs text-gray-500 leading-relaxed">Visualización de novedades, faltantes y trazabilidad de las auditorías.</p>
              </div>
              <div className="mt-6 flex items-center justify-between">
                <span className="text-[11px] font-bold px-3 py-1 rounded-full text-purple-700 bg-purple-50 border border-purple-100">Consultas</span>
                <span className="text-xs font-bold text-purple-600 group-hover:translate-x-1 transition-transform">Ingresar ›</span>
              </div>
            </div>
          )}

        </div>
      )}
    </div>
  );
}